<!--
<template>
  <header>
    &lt;!&ndash; Topbar &ndash;&gt;
    <div class="topbar d-flex justify-content-between align-items-center px-4 py-2">
      &lt;!&ndash; Left: Contact info &ndash;&gt;
      <div class="d-flex gap-4 align-items-center topbar-info">
        <span>
          <i class="bi bi-envelope-fill me-2"></i> customercare@one4all.com.gh
        </span>
        <span>
          <i class="bi bi-telephone-fill me-2"></i> (+243)839-368-332, 243 808
        </span>
      </div>

      &lt;!&ndash; Right: Socials + language &ndash;&gt;
      <div class="d-flex align-items-center gap-2">
        <a href="#" class="icon-box"><i class="bi bi-facebook"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-twitter"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-linkedin"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-instagram"></i></a>

        <button class="lang-button text-muted">Eng</button>
        <button class="lang-button active">Fr</button>
      </div>
    </div>

    &lt;!&ndash; Main navbar &ndash;&gt;
    <nav class="navbar navbar-expand-lg navbar-light bg-white py-4 shadow-sm">
      <div class="container-fluid px-4 d-flex flex-column align-items-center">
        &lt;!&ndash; Logo centered &ndash;&gt;
        <div class="d-flex align-items-center gap-3 mb-3">
          <img src="@/assets/logo_one4all.png" alt="One4All Logo" class="logo-small" />
        </div>

        &lt;!&ndash; Nav links centered &ndash;&gt;
        <div class="d-flex flex-wrap gap-4 justify-content-center nav-links">
          <router-link to="/" class="nav-link">Domicile</router-link>
          <router-link to="/products" class="nav-link">Produits</router-link>
          <router-link to="/africa" class="nav-link">Présence Africaine</router-link>
          <router-link to="/gateways" class="nav-link">Nos Passerelles Universelles</router-link>
          <router-link to="/faqs" class="nav-link">FAQs</router-link>
          <router-link to="/about" class="nav-link">À Propos De Nous</router-link>
          <router-link to="/contact" class="nav-link">Contact</router-link>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'NavbarView'
}
</script>

<style scoped>
/* Topbar */
.topbar {
  background-color: #ffffff;
  border-bottom: 1px solid #e9ecef;
  color: #333;
}

.topbar-info span {
  font-weight: 500;
}

/* Logos */
.logo {
  height: 55px;
}
.logo-small {
  height: 55px;
}

/* Social icon box */
.icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border: 1px solid #ccc;
  color: #333;
  border-radius: 2px;
  transition: all 0.2s;
}
.icon-box:hover {
  background-color: #42b983;
  color: white;
  border-color: #42b983;
}

/* Language buttons */
.lang-button {
  border: 1px solid #ccc;
  background: none;
  font-size: 1rem;
  font-weight: 500;
  padding: 4px 12px;
  margin-left: 5px;
  border-radius: 2px;
}
.lang-button.active {
  background-color: #000c7a;
  color: white;
  border-color: #000c7a;
}

/* Nav links */
.nav-links .nav-link {
  font-size: 1.25rem; /* ⬆️ Plus gros */
  font-weight: 600;
  color: #2c3e50;
  text-decoration: none;
  transition: color 0.3s;
}
.nav-links .nav-link:hover,
.nav-links .router-link-exact-active {
  color: #42b983;
}
</style>
-->

<!--<template>
  <header>
    &lt;!&ndash; Topbar &ndash;&gt;
    <div class="topbar d-flex justify-content-between align-items-center px-4 py-2">
      &lt;!&ndash; Left: Contact info &ndash;&gt;
      <div class="d-flex gap-4 align-items-center topbar-info">
        <span>
          <i class="bi bi-envelope-fill me-2"></i> customercare@prymodrc.com
        </span>
        <span>
          <i class="bi bi-telephone-fill me-2"></i> (+243) 839-368-332
        </span>
      </div>

      &lt;!&ndash; Right: Socials + language &ndash;&gt;
      <div class="d-flex align-items-center gap-2">
        <a href="#" class="icon-box"><i class="bi bi-facebook"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-twitter"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-linkedin"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-instagram"></i></a>

        <button class="lang-button text-muted">Eng</button>
        <button class="lang-button active">Fr</button>
      </div>
    </div>

    &lt;!&ndash; Main navbar &ndash;&gt;
    <nav class="navbar navbar-expand-lg navbar-light bg-white py-4 shadow-sm">
      <div class="container-fluid px-4 d-flex flex-column align-items-center">
        &lt;!&ndash; Logo centered &ndash;&gt;
        <div class="d-flex align-items-center gap-3 mb-3">
          <img src="@/assets/logo_prymo.png" alt="PRYMO Logo" class="logo-small" />
        </div>

        &lt;!&ndash; Nav links centered &ndash;&gt;
        <div class="d-flex flex-wrap gap-4 justify-content-center nav-links">
          <a href="#section1" class="nav-link">Domicile</a>
          <a href="#section7" class="nav-link">Nos Cibles</a>
          <a href="#section2" class="nav-link">Nos Solutions</a>
          <a href="#section3" class="nav-link">Solutions Web</a>
          <a href="#section5" class="nav-link">Solutions Téléphoniques</a>
          <a href="#section4" class="nav-link">Nos Clients</a>
          <a href="#section6" class="nav-link">Pourquoi Prymo</a>
          <a href="#contact" class="nav-link">Contact</a>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'NavbarView'
}
</script>-->
<template>
  <header>
    <!-- Topbar -->
    <div class="topbar d-flex justify-content-between align-items-center px-4 py-2">
      <!-- Left: Contact info -->
      <div class="d-flex gap-4 align-items-center topbar-info">
        <span>
          <i class="bi bi-envelope-fill me-2"></i> customercare@prymodrc.com
        </span>
        <span>
          <i class="bi bi-telephone-fill me-2"></i> (+243) 839-368-332
        </span>
      </div>

      <!-- Right: Socials + language -->
      <div class="d-flex align-items-center gap-2">
        <a href="#" class="icon-box"><i class="bi bi-facebook"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-twitter"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-linkedin"></i></a>
        <a href="#" class="icon-box"><i class="bi bi-instagram"></i></a>

        <button class="lang-button text-muted">Eng</button>
        <button class="lang-button active">Fr</button>
      </div>
    </div>

    <!-- Main navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white py-4 shadow-sm">
      <div class="container-fluid px-4 d-flex flex-column align-items-center">
        <!-- Logo centered -->
        <div class="d-flex align-items-center gap-3 mb-3">
          <img src="@/assets/logo_prymo.png" alt="PRYMO Logo" class="logo-small" />
        </div>

        <!-- Nav links centered -->
        <div class="d-flex flex-wrap gap-4 justify-content-center nav-links">
          <a @click="scrollTo('section1')" class="nav-link">Domicile</a>
          <a class="nav-link" @click="scrollTo('section7')" >Nos Cibles</a>
          <a @click="scrollTo('section2')" class="nav-link">Nos Solutions</a>
          <a @click="scrollTo('section3')" class="nav-link">Solutions Web</a>
          <a @click="scrollTo('section5')" class="nav-link">Solutions Téléphoniques</a>
          <a @click="scrollTo('section4')" class="nav-link">Nos Clients</a>
          <a @click="scrollTo('section6')" class="nav-link">Pourquoi Prymo</a>
          <a @click="scrollTo('footer')" class="nav-link">Contact</a>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'NavbarView',
  methods: {
    scrollTo(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>


<style scoped>
/* Topbar */
.topbar {
  background-color: #ffffff;
  border-bottom: 1px solid #e9ecef;
  color: #333;
}

.topbar-info span {
  font-weight: 500;
}

/* Logos */
.logo {
  height: 55px;
}
.logo-small {
  height: 55px;
}

/* Social icon box */
.icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border: 1px solid #ccc;
  color: #333;
  border-radius: 2px;
  transition: all 0.2s;
}
.icon-box:hover {
  background-color: #42b983;
  color: white;
  border-color: #42b983;
}

/* Language buttons */
.lang-button {
  border: 1px solid #ccc;
  background: none;
  font-size: 1rem;
  font-weight: 500;
  padding: 4px 12px;
  margin-left: 5px;
  border-radius: 2px;
}
.lang-button.active {
  background-color: #000c7a;
  color: white;
  border-color: #000c7a;
}

/* Nav links */
.nav-links .nav-link {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  text-decoration: none;
  transition: color 0.3s;
}
.nav-links .nav-link:hover,
.nav-links .router-link-exact-active {
  color: #42b983;
}
</style>